import React, {Component} from "react";
import ReactTags from '../../Components/ReactTags';
import Wrp from '../../hoc/Wrp/Wrp';
import Autocomplete from "../../Components/AutoComplete";

import { callPOST,callGET } from '../../Utils/ApiUtil';
import {getSelectedValueBasedOnField,isSet} from '../../Utils/CommonFunctions';
import { LOOKUP_API_FIELD_ID,API_STATUS_SUCCESS,USERS_WINDOW_ID,RATE_SHEET_WINDOW_ID,ORGANIZATION_WINDOW_ID,EMAIL_WINDOW_ID,PROFILE_WINDOW_ID,NOTES_WINDOW_ID,CUSTOM_WINDOW_ID } from '../../Global/Constants';
import {getUserInfo} from '../../Utils/UserFunctions';

const KeyCodes = {
    comma: 188,
    enter: 13,
};
let delimiters = [KeyCodes.comma, KeyCodes.enter];

class LookupField extends Component{

	state = {
        tags:null,
        lookupAutoComplete:null,
  	}

  	componentDidMount = ()=>{
  		const {lookupWindowName} = this.props;
  		if(lookupWindowName && lookupWindowName!=='')
        	this.lookupFormsList('',lookupWindowName);
  	}

  	componentDidUpdate =(prevProps,prevState)=>{
       if(prevProps.lookupWindowName !== this.props.lookupWindowName) {
            this.lookupFormsList('',this.props.lookupWindowName);
        }
    }

	// DELETE/CANCEL ADDED LOOKUP VALUES
 	handleDelete = (i) => {
        this.props.handleDelete(i);
    }

    //ADD WHEN SELECT FROM SUGGESTION
    handleAddition = (tag) => {
    	console.log(1,tag);
        this.props.handleInputChange(tag);
    }

    //SEARCHING AND LIST VALUES FROM LIST ON KEYUP
    handleInputChange = (suggestion)=>{
    	const {lookupWindowName} = this.props;
        if(lookupWindowName && lookupWindowName!=='')
        	this.lookupFormsList(suggestion,lookupWindowName);
    }

    handleTagClick = (index,actionType) => {
        console.log(index,actionType);
    }

    handleInputFocus = (value,data) => {
    	// if(data.lookupWindowName && data.lookupWindowName!=='')
        	// this.lookupFormsList(value,data.lookupWindowName);
    }

    //LIST OF SEARCH FIELD FROM LOOKUP FIELD  
	lookupFormsList =(value,windowName) =>{		
		const {lookupWindowNameId,isNotes} = this.props;
		const userInfo = getUserInfo();
	    const page = 0;//pagination.page; 
	    const orderBy = '';//pagination.orderBy; 
	    const perPage = 10;//pagination.perPage; 
	    const direction = 'ASC';//pagination.direction; 
	    const search = value;
	    const queryString = '?query='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction;
	    const emailQueryString = '&query='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction;

	    let API_URL = '';
	    // console.log(defaultConfig);
	    //console.log('lookupWindowName lookupFormsList===',isNotes,lookupWindowNameId)
	    if(LOOKUP_API_FIELD_ID[lookupWindowNameId] || (isNotes && isNotes===true)) {
	    	if(isNotes && isNotes === true) {
	            API_URL = LOOKUP_API_FIELD_ID[NOTES_WINDOW_ID]+queryString;
	        }else if(EMAIL_WINDOW_ID === lookupWindowNameId) {
	    		API_URL = LOOKUP_API_FIELD_ID[lookupWindowNameId]+emailQueryString;
	    	}else {
	    		API_URL = LOOKUP_API_FIELD_ID[lookupWindowNameId]+queryString;
	    	}
	    	API_URL = API_URL.replace('{WINDOW_ID}', lookupWindowNameId);
	    	if(userInfo.data && userInfo.data.default_emailconfig_id) {
	    		API_URL = API_URL.replace('{EMAIL_CONFIG_ID}', userInfo.data.default_emailconfig_id);
	    	}else {
	    		API_URL = API_URL.replace('{EMAIL_CONFIG_ID}', '');
	    	}
	    	callGET(API_URL)
	        .then(response => {
	            const responseData = response.data;
	        	if(responseData.code === API_STATUS_SUCCESS) {
	        		let datalist = [];//ORGANIZATION_WINDOW_ID === lookupWindowNameId ? responseData.data.organization_list.content : responseData.data.content;
	        		if(ORGANIZATION_WINDOW_ID === lookupWindowNameId) {
	        			if(responseData.data.organization_list.content) {
	        				datalist = responseData.data.organization_list.content;
	        			}
	        		}else if(responseData.data && responseData.data.content) {
        				datalist = responseData.data.content;
        			}else if(CUSTOM_WINDOW_ID === lookupWindowNameId) {
	        			if(responseData.data.windows.content) {
	        				datalist = responseData.data.windows.content;
	        			}
	        		}
	        		let updateTableData = [];
	        		if(datalist.length > 0) {
		    		  
			          datalist.map((arr,i) => {
			          	let value = '';
			          	if(isNotes && isNotes===true) {
			          		value = {
	                          label:arr.note_content ? arr.note_content.substring(0, 20) : '',
	                          text:arr.note_content ? arr.note_content.substring(0, 20) : '',
	                          value:arr.id,
	                          id:arr.id
	                        }
			          	}else if(USERS_WINDOW_ID.indexOf(lookupWindowNameId) !== -1) {
			          		value = {
				              label:arr.last_name +' '+ arr.first_name,
				              text:arr.last_name +' '+ arr.first_name,
			                  value:arr.id,
			                  id:arr.id
				            }
			          	}else if(RATE_SHEET_WINDOW_ID === lookupWindowNameId) {
			          		value = {
				              label:arr.name,
				              text:arr.name,
			                  value:arr.id,
			                  id:arr.id
				            }
			          	}else if(ORGANIZATION_WINDOW_ID === lookupWindowNameId) {
			          		value = {
				              label:arr.organization_name,
				              text:arr.organization_name,
			                  value:arr.id,
			                  id:arr.id
				            }
			          	}else if(EMAIL_WINDOW_ID === lookupWindowNameId) {
			          		value = {
				              label:arr.subject,
				              text:arr.subject,
			                  value:arr.id,
			                  id:arr.id
				            }
			          	}else if(PROFILE_WINDOW_ID === lookupWindowNameId) {
			          		value = {
				              label:arr.profile_name,
				              text:arr.profile_name,
			                  value:arr.id,
			                  id:arr.id
				            }
			          	}else if(CUSTOM_WINDOW_ID === lookupWindowNameId) {
			          		value = {
				              label:arr.display_name,
				              text:arr.display_name,
			                  value:arr.id,
			                  id:arr.id
				            }
			          	}
			            
			            updateTableData.push(value);
			      	  })
			      	}
			      	if(updateTableData && updateTableData.length > 0) {
		          		this.setState({lookupAutoComplete: updateTableData});	
		          	}else {
		          		updateTableData.push({
			                text:'No records found'
			            });
		          		this.setState({lookupAutoComplete: updateTableData});
		          	}
	        	}else {
	        		this.setState({lookupAutoComplete:[{
		                text:'No records found'
		            }]});
	        	}
	        }, (error) => {
	            console.log(error);
	            this.setState({lookupAutoComplete:[{
	                text:'No records found'
	            }]});
	        })
	    }else {
	    	//API_URL = 'table-data-engine/'+windowName+'/metatable/record-list/active'+queryString;
	    	API_URL = 'table-data-engine/'+windowName+'/metatable/dropdown-list/active'+queryString;
		    callGET(API_URL,{})
		    .then(res => {
		      // console.log(res);
		      if(res.status===200){ 
		        const response = res.data;
		        
		        if(response.code===200){
		          let updateTableData = [];
		          let fieldsRow;
		          let defaultDisFieldsRow;
		         
		          response.data.value_list.content.map((contentData,contentIndex)=>{
		            fieldsRow = [];
		            let fieldsTableRow  = {};
		            defaultDisFieldsRow = [];
		            
		            /*contentData.fields.map((item)=>{
		              item.selectedValue = item.value;
		              item.element = (item.element_type==='PickList')?'TextInput':item.element_type;
		              item.options = [];
		              const selectedValue = getSelectedValueBasedOnField(item);
		              fieldsTableRow = {
		                ...fieldsTableRow,
		                [item.table_descriptor_id]:{
		                  isDefaultDisplay:false,//item.is_default_displayname,
		                  value:selectedValue
		                }
		              }
		              // console.log(typeof selectedValue)
		              if(selectedValue!=='' && selectedValue!==undefined && selectedValue!==null && selectedValue!=='-' && typeof selectedValue !== 'object'){
		                fieldsRow.push(selectedValue);
		                //console.log(fieldsRow);
		                if(item.is_default_displayname===true && defaultDisFieldsRow.length<2){
		                  defaultDisFieldsRow.push(selectedValue);
		                }
		              }
		          	});
		          	const endPos = (fieldsRow.length<=2)? fieldsRow.length:3;
		            fieldsRow = (defaultDisFieldsRow.length===0)?fieldsRow.slice(0,endPos):defaultDisFieldsRow;
		            updateTableData.push({
		                text:fieldsRow.join(','),
		                label:fieldsRow.join(','),
		                value:contentData.meta_table_id,
		                id:contentData.meta_table_id,
		            });*/
		            updateTableData.push({
		                text:contentData.dpnm,
		                label:contentData.dpnm,
		                value:contentData.id,
		                id:contentData.id,
		            });
		        });
		          	// setLookupAutoComplete(updateTableData);
		          	if(updateTableData && updateTableData.length > 0) {
		          		this.setState({lookupAutoComplete: updateTableData});	
		          	}else {
		          		updateTableData.push({
			                text:'No records found'
			            });
		          		this.setState({lookupAutoComplete: updateTableData});
		          	}
			        
		        }else{
		            this.setState({lookupAutoComplete:[{
			                text:'No records found'
			            }]});
		            // setLookupAutoComplete([]);
		        }
		      }
		    }, (error) => {
	            console.log(error);
	            this.setState({lookupAutoComplete:[{
	                text:'No records found'
	            }]});
	        })
		}
	  }

	  

	render() {

		

		const {values,lookupWindowNameId,isSingleField} = this.props;
		const {lookupAutoComplete} = this.state;
		let updatedAutoLookup =[];
		isSet(lookupAutoComplete,[]).map(data=>{
			let found =false;
			isSet(values,[]).forEach(val=>{
				if(data.id===val.id){
					found=true;
				}
			});
			if(!found){
				updatedAutoLookup.push(data);
				found=false;
			}
		});
		
		const attributes = {
	        className:"form-control form-control-sm custom-arrow",
	        placeholder:"Select..."
      	}
      	
	  try{
	  	return (
			<div>
			{ isSingleField && isSingleField === true ?
				<Autocomplete
                    attributes={attributes}
                    suggestions={updatedAutoLookup?updatedAutoLookup:[]}
                    search={e=>this.handleInputChange(e)}
                    select={this.handleAddition}
                    selectedValue={values?values:''}
                    {...this.props}
                />
            :
            <div>
			<ReactTags
	            tags={values && Array.isArray(values)?values:[]}
	            placeHolder={'Search here..'}
	            suggestions={isSet(updatedAutoLookup,[])}
	            showAll={true}
	            delimiters={delimiters}
	            handleDelete={this.handleDelete}
	            handleAddition={this.handleAddition}
	            handleInputChange={e=>this.handleInputChange(e)}
	            handleTagClick={this.handleTagClick}
	            handleInputFocus={e=>this.handleInputFocus(e)}
	            allowAdditionFromPaste={false}
	        /> 
	        </div>
	    }
	        </div>
		)
	  }catch(e){
	  	//console.log('exc',e)
	  	return null;
	  }
		
	}
}

export default LookupField;